import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getArchivedPlusNormalPersonnel, StateStatus } from '@guryou/redux';

const useAllResources = (stateSelector, ids, archivedAsWell = true) => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(stateSelector);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getArchivedPlusNormalPersonnel(null, archivedAsWell));
    }
  }, [archivedAsWell, dispatch, status]);

  if (data && ids) {
    const resourceIds = Array.isArray(ids) ? ids : ids.split(',').map(x => +x);
    return { data: data.filter(x => resourceIds.includes(x.id)), status, version };
  }

  return { data: data || [], status, version, entity };
};

export default useAllResources;
